import React, { useState } from "react";
import orangeTopImg from "../../assets/images/png/orange_top_vector.png";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import benefitsImg from "../../assets/images/coursesPage/benefits/webp/benifits.webp";
import greatSoulImg2 from "../../assets/images/the-great-souls/webp/greateSolusImg2.webp";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";

const AshramaBenefits = () => {
  const [showAll, setShowAll] = useState(false);
  const handleViewAllClick = () => {
    setShowAll(!showAll);
  };
  return (
    <>
      <div className="position-relative">
        <img
          className="position-absolute end-0 w-100 common_orange_bottom_layer_top common_orange_bottom_layer_top_2"
          src={orangeTopImg}
          alt="orange_top_vector"
        />
        {/*<img
          className="position-absolute bottom_flower_mahamantra bottom_flower_benefits supreme_right_flower end-0"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/}
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls ok"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra benefits_top_flower start-0"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-2 mt-md-4 mt-lg-5 places_section_space">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2 pt-4 pt-sm-5 pt-md-0">
              <CommonHeading
                heading="Hari Om Tatsat Jai Guru Datta"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                Benefits Of Mahamantra
              </h2>
            </div>
          </div>
          <div className="row mb-4 pb-4 position-relative z-3">
            <div className="col-md-6 col-lg-5 ps-lg-0 mx-auto mb-4 mb-lg-0">
              <div className="position-relative text-center">
                <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 pb-lg-5 mb-3 mb-lg-2">
                  <div className="position-relative z-3 mx-auto">
                    <Button title="Lord Dattatreya" className="lord_btn" />
                  </div>
                </div>
                <img
                  src={benefitsImg}
                  className="w-100 max_sm_w d-none d-lg-block"
                  alt="benifits"
                />
                <img
                  src={greatSoulImg2}
                  className="w-100 max_sm_w d-lg-none"
                  alt="greateSolusImg2"
                />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="d-flex gap-2 mb-md-3 mb-2 pb-3 border-bottom px-3 px-sm-0">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick-img" />
                <p className="common_para mb-0 pe-xl-5 lh_25">
                  You will spontaneously experience the state of Meditation that
                  is so sought after by sadhus and sannyasins and seekers in all
                  nations of the world
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2 pb-3 border-bottom px-3 px-sm-0">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick-img" />
                <p className="common_para mb-0 pe-xl-4 lh_25">
                  Via that repeated experience, your health will increase in
                  strength and resilience
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2 pb-3 border-bottom px-3 px-sm-0">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick-img" />
                <p className="common_para mb-0 pe-xl-4 lh_25">
                  The finest spiritual tool on the planet is designed to
                  continually uplift your spiritual progress
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2 pb-3 border-bottom px-3 px-sm-0">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick-img" />
                <p className="common_para mb-0 pe-xl-3 lh_25">
                  You will receive a Yoga Asana practice that will uphold your physical integrity
                  and improve your entire well-being
                </p>
              </div>
              <div className={`${!showAll ? "d-none d-lg-block" : ""}`}>
                <div className="px-3 px-sm-0">
                  <div className="d-flex gap-2 mb-md-3 mb-2 pb-3 border-bottom">
                    <img
                      src={orangeTick}
                      className="mb-auto mt-1"
                      alt="tick-img"
                    />
                    <p className="common_para mb-0 pe-sm-5 lh_25">
                      Continued spiritual guidance as a free gift from The Sole Giver is available, should you wish.
                    </p>
                  </div>
                  <div className="d-flex gap-2 mb-md-3 mb-2 pb-3">
                    <img
                      src={orangeTick}
                      className="mb-auto mt-1"
                      alt="tick-img"
                    />
                    <div>
                      <p className="common_para mb-0 pe-sm-5 lh_25">
                        The meditative state of Sahaj Dhyan Yoga (The Yoga of
                        Spontaneous Meditation) will grace you with gifts too
                        many to list in full, a handful being
                      </p>
                      <ul>
                        <li className="common_para mb-0 pe-5 mt-3">
                          Daily experience of your true self.
                        </li>
                        <li className="common_para mb-0 pe-sm-5 mt-3 lh_25">
                          Confidence of being on the spiritual path walked by
                          Rishis, Sages, Saints and Yogis from time immemorial.
                        </li>
                        <li className="common_para mb-0 pe-sm-2 mt-3 lh_25">
                          Shaktipad transference of blessing from the Guru
                          Tattwa at the deepest level to support your unique
                          dharmic expressions and your universal being.
                        </li>
                        <li className="common_para mb-0 pe-sm-5 mt-3 lh_25">
                          Participation in your own GPS (Guru Protection
                          System), such that your life will be guided by Supreme
                          Intelligence in harmony with all the ways of Beauty.
                        </li>
                        <li className="common_para mb-0 pe-sm-5 mt-3 lh_25">
                          Insight into the mechanics of Creation whereby each
                          soul is born to enact the fullness of human potential.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-3 mt-lg-4 pt-1 position-relative w_fit_content mx-auto d-lg-none">
                <Button
                  title={showAll ? "View Less" : "View All"}
                  onClick={handleViewAllClick}
                  className="view_all_btn2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AshramaBenefits;
